import { createStore, withProps } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { withPagination } from '@ngneat/elf-pagination';
import { withRequestsStatus } from '@ngneat/elf-requests';
import {
    AuditOffer,
    AuditOfferGroupedDto,
    ContractStore,
    OfferActionArray,
    OfferFormalizationAction
} from './audit-offer.model';
import {EngagedSupplierData} from '@screens/admin/audits/audit-detail/tabs/AuditsOfferFormalization.tab';


export interface AuditsOfferState {
  version?: number;
  auditOffers?: AuditOfferGroupedDto[];
  actionArray : OfferActionArray;
  auditsFormalizationAction: OfferFormalizationAction;
  contract: ContractStore;
  engagedSuppliers: EngagedSupplierData[];
}


export const auditOfferStore = createStore(
  { name: 'auditOffer' },
  withEntities<AuditOffer, 'auditOperationId'>({ idKey: 'auditOperationId' }),
  withProps<AuditsOfferState>({
    actionArray: {
      auditOfferIds: [],
    },
    auditsFormalizationAction: {
      auditOfferIds: [],
    },
    contract: {
      open: false,
    },
    engagedSuppliers: [],
  }),
  withPagination(),
  withRequestsStatus()
);
